module.exports = __webpack_public_path__ + "media/images/documents/pdf-format-951b6ffd3d3847b04cdbbee84aa47a5b.jpg";